export * from './constant-product-history';
export * from './constant-trending-product';
export * from './constant-top-discount';
export * from './constant-best-selling';
export * from './constant-quick-view';
export * from './constant-select-theme';

export const CHANGE_APP_STATUS = 'CHANGE_APP_STATUS';
export const CHANGE_APP_STATUS_RESULT = 'CHANGE_APP_STATUS_RESULT';
export const CHANGE_THEME = 'CHANGE_THEME';
// Reset save
export const RESET_CHANGE_STATUS_APP_RESULT = 'RESET_CHANGE_STATUS_APP_RESULT';
// NOTIFICATION
export const GET_LIST_NOTIFICATION = 'GET_LIST_NOTIFICATION';
export const GET_LIST_NOTIFICATION_RESULT = 'GET_LIST_NOTIFICATION_RESULT';
export const GET_NOTIFICATION_DETAIL = 'GET_NOTIFICATION_DETAIL';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const GET_NOTIFICATION_DETAIL_RESULT = 'GET_NOTIFICATION_DETAIL_RESULT';

export const GET_PLAN_PACKAGE = 'GET_PLAN_PACKAGE';
export const GET_PLAN_PACKAGE_REUSLT = 'GET_PLAN_PACKAGE_REUSLT';
export const UPGRADE_PLAN_PACKAGE = 'UPGRADE_PLAN_PACKAGE';
export const UPGRADE_PLAN_PACKAGE_RESULT = 'UPGRADE_PLAN_PACKAGE_RESULT';
export const BUY_MORE_PACKAGE = 'BUY_MORE_PACKAGE';
export const BUY_MORE_PACKAGE_RESULT = 'BUY_MORE_PACKAGE_RESULT';
export const RESET_PACKAGE_RESULT_STATUS = 'RESET_PACKAGE_RESULT_STATUS';

export const GET_DATA_SHOP = 'GET_DATA_SHOP';
export const SET_DATA_SHOP_RESULT = 'SET_DATA_SHOP_RESULT';

export const GET_STATISTIC_CHART = 'GET_STATISTIC_CHART';
export const GET_STATISTIC_CHART_RESULT = 'GET_STATISTIC_CHART_RESULT';
export const GET_REPORT_APP = 'GET_REPORT_APP';
export const GET_REPORT_APP_RESULT = 'GET_REPORT_APP_RESULT';

export const CHANGE_SAVER_BAR_SETTINGS_FIELD = 'CHANGE_SAVER_BAR_SETTINGS_FIELD';
export const GET_SETTING_APP = 'GET_SETTING_APP';
export const GET_SETTING_APP_RESULT = 'GET_SETTING_APP_RESULT';

export const GET_TOP_PRODUCTS_VIEWED = 'GET_TOP_PRODUCTS_VIEWED';
export const GET_TOP_PRODUCTS_VIEWED_RESULT = 'GET_TOP_PRODUCTS_VIEWED_RESULT';
export const SET_CHECK_VARIANTS = 'SET_CHECK_VARIANTS';
